<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="@/assets/logo.png" class="img-avatar" alt="user" />
    </template>
    <template slot="dropdown">
      <b-dropdown-item>
        <i class="fa fa-key" /> Password
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout()">
        <i class="fa fa-lock" /> Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import firebase from "firebase/app";
import Swal from "sweetalert2";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 };
  },
  methods: {
    async logout() {
      Swal.showLoading();
      await firebase.auth().signOut();
      this.$router.replace("login");
      Swal.close();
    }
  }
};
</script>
